import { defineComponent as _defineComponent } from 'vue'

import DateUtil from "@/modules/utils/dateUtil";

interface Props {
	/**
	 * 投稿日。
	 */
	talkRoomDate: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    talkRoomDate: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * 投稿日。
	 */
	talkRoomDate: string;
}
/**
 * トークルーム情報 > 投稿日。
 */



/**
 * 投稿日を`YYYY.MM.DD`のString型に変換。
 * ユーザーの入力値で動的に変更される値ではない為、reactiveにする必要はなし。
 */
const convertDate = DateUtil.convertDiplayFormat(props.talkRoomDate);

const __returned__ = { props, convertDate }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})